import React from 'react'
import { Link } from 'react-router-dom'

import { Button } from '@pepper/ui'

import Artwork403 from 'assets/images/403_artwork.png'
import Artwork404 from 'assets/images/404_artwork.png'

import styles from './_.module.css'

interface ErrorTemplateProps {
  statusCode: 403 | 404
  error: { title: string; message: string }
}

const ErrorTemplate = ({
  statusCode,
  error,
}: ErrorTemplateProps): JSX.Element => {
  return (
    <div className={styles.wrapper}>
      {statusCode === 404 && (
        <img
          src={Artwork404}
          alt="artwork 404"
          height={'329px'}
          width={'443px'}
          className={styles.artwork}
        />
      )}
      {statusCode === 403 && (
        <img
          src={Artwork403}
          height={'269px'}
          width={'227px'}
          alt="artwork 403"
          className={styles.artwork}
        />
      )}
      <div className={styles.content}>
        <h1 className={styles.heading}>{error.title}</h1>
        <span className={styles.textMessage}>{error.message}</span>
        <Link to="/">
          <Button type="primary" href="/">
            Go Back to Dashboard
          </Button>
        </Link>
      </div>
    </div>
  )
}

export default ErrorTemplate
